<template lang="pug">
	.merchant-success
		VueFeedback(type="success")
			template(slot="feedback-title") Köszönjük jelentkezését!
			template(slot="feedback-content") Munkatársunk hamarosan keresni fogja Önt a megadott elérhetőségek egyikén.
</template>
<script>
import VueFeedback from '@ui-common/vue-feedback';
export default {
	components: {
		VueFeedback
	},
	mounted() {
		this.$scrollTo(this.$el);
	}
};
</script>
